import { PickType } from '@okletsplay/core';
import React, { FC, memo } from 'react';

interface PickTypeFormatProps {
  type?: PickType | unknown;
}

const PICK_TYPE_LABELS: Record<PickType, string> = {
  [PickType.BlindPick]: 'Blind Pick',
  [PickType.AllRandom]: 'All Random',
  [PickType.DraftMode]: 'Draft Mode',
  [PickType.TournamentDraft]: 'Tournament Draft',
};

const PickTypeFormatComponent: FC<PickTypeFormatProps> = ({ type }) => {
  if (!type) {
    return null;
  }

  return <>{PICK_TYPE_LABELS[type as PickType]}</>;
};

export const PickTypeFormat = memo(PickTypeFormatComponent);
